import { FEATURE_KEYS } from 'utils/billingFeatures.constants';

// Step 5 of the settings flow is the plan picker — the screen that actually
// sells a plan. /billing is a level above it, so sending a merchant there when
// their trial has run out costs them a click to reach the thing they came for.
// The billing page's own selectPlan() already pushes this exact shape.
const SETTINGS_PLAN_STEP = 5;

/**
 * Where "Choose a plan" goes. userId and businessAccountId are carried through
 * whenever the current route has them — every billing screen is reachable both
 * as the merchant and as support acting on their behalf, and dropping them
 * silently switches which account is being paid for.
 */
export function buildChoosePlanPath({ featureKey = FEATURE_KEYS.WEBSITE, userId, businessAccountId } = {}) {
  const query = new URLSearchParams({ step: String(SETTINGS_PLAN_STEP), featureKey });

  if (userId && businessAccountId) {
    query.set('userId', userId);
    query.set('businessAccountId', businessAccountId);
  }

  return `/settings?${query.toString()}`;
}

export default buildChoosePlanPath;
